import { Button, Card, Flex, Spin, Statistic } from 'antd';
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { FaArrowTrendUp } from 'react-icons/fa6';
const RevenueAnalysis = ({ t, dataSales }) => {
  const { darkMode } = useSelector((state) => state.user);
  const { sales_invoice_dist, sales_invoice_header } = dataSales || {};
  const isArabic = 'ar' === true;
  const [mode, setMode] = React.useState('All');
  const seriesTwo = [
    {
      name: 'Total Sales Orders',
      data:
        sales_invoice_dist?.map((item) => item.total_sales_order_count) || [],
    },
  ];

  const optionsTwo = {
    chart: {
      type: 'bar',
      height: 350,
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        // horizontal: true,
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    // dataLabels: {
    //   enabled: false,
    // },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories:
        sales_invoice_dist?.map((item) => item['MONTHNAME(posting_date)']) ||
        [],
      // reversed: false,
    },
    // colors: ['#1BC5C2', '#7979D3', '#7C9CD7', '#1AA1D1','#A3D6FE'],
    colors: ['#0b9640'],
    dataLabels: {
      enabled: true,
      formatter: function (_val, { dataPointIndex }) {
        return `${sales_invoice_dist[dataPointIndex].grand_total} SAR`;
      },
      // offsetY: -10,
      style: {
        fontSize: '14px',
        // colors: ['#26491e'],
        fontWeight: 'bold',
      },
    },
    yaxis: {
      title: {
        text: 'Total Sales Orders',
      },
    },
    tooltip: {
      theme: darkMode ? 'dark' : 'light',
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      floating: true,
    },
    responsive: [
      {
        breakpoint: 720,
        options: {
          chart: {
            height: 300,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };
  return (
    <>
      <Card
        className="card-graph-dashboard-revenue"
        style={{ height: '100%' }}
        title={
          <Flex justify="space-between" align="center">
            <h3
              style={{
                fontSize: '16px',
                margin: '0 0 7px 0',
                fontWeight: 600,
                color: '#495057',
              }}
            >
              {t.salesInvoice}
            </h3>
          </Flex>
        }
      >
        {false ? (
          <div
            style={{
              width: '100%',
              height: '30vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin
              indicator={
                <LoadingOutlined style={{ fontSize: 30 }} spin size="large" />
              }
            />
          </div>
        ) : (
          <div
            className={
              darkMode ? 'dark-chart responsive-chart' : 'responsive-chart'
            }
          >
            <div className="bg-[#e9ebec8c] grid grid-cols-2 gap-4 lg:grid-cols-4 px-[20px] text-center">
              <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
                <h2 className="text-[#495057] font-[600] text-[17px]">
                  {' '}
                  {sales_invoice_header[0]?.total_sales_order_count}
                </h2>
                <p className="text-[#878a99] font-[500] text-[14px]">
                  {t.Count}
                </p>
              </div>
              <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
                <h2 className="text-[#495057] font-[600] text-[17px]">
                  {sales_invoice_header[0]?.grand_total}{' '}
                  <span className="text-[10px] font-[400] text-[#878a99]">
                    {t.SAR}
                  </span>
                </h2>
                <p className="text-[#878a99] font-[500] text-[14px]">
                  {t.Total}
                </p>
              </div>
              <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
                <h2 className="text-[#495057] font-[600] text-[17px]">
                  {sales_invoice_header[0]?.outstanding_amount}{' '}
                  <span className="text-[10px] font-[400] text-[#878a99]">
                    {t.SAR}
                  </span>
                </h2>
                <p className="text-[#878a99] font-[500] text-[14px]">
                  {t.outstanding}
                </p>
              </div>
              <div className=" p-4">
                <h2 className="text-[#495057] font-[600] text-[17px]">
                  {sales_invoice_header[0]?.total_taxes_and_charges}{' '}
                  <span className="text-[10px] font-[400] text-[#878a99]">
                    {t.SAR}
                  </span>
                </h2>
                <p className="text-[#878a99] font-[500] text-[14px]">
                  {t.taxes}
                </p>
              </div>
            </div>
            <div id="chart" className="p-[20px]">
              <ReactApexChart
                options={optionsTwo}
                series={seriesTwo}
                type="bar"
                // type="treemap"
                height={350}
                key={mode}
              />
            </div>
            <div id="html-dist"></div>
          </div>
        )}
      </Card>
    </>
  );
};

export default RevenueAnalysis;
